import { getApiError } from '@/configs/axios.config'
import type { AllowedApp } from '@/types/api'

/** Inline save error: the backend's message for a 4xx, else the fixed line. */
export function saveErrorMessage(error: unknown, fallback: string): string {
  const { statusCode, message } = getApiError(error)
  return statusCode !== undefined && statusCode >= 400 && statusCode < 500
    ? message
    : fallback
}

export function sameAllowedApps(
  a: readonly AllowedApp[],
  b: readonly AllowedApp[]
): boolean {
  if (a.length !== b.length) return false
  const sortedA = [...a].sort()
  const sortedB = [...b].sort()
  return sortedA.every((value, index) => value === sortedB[index])
}
